{
  "_format": "hh-sol-artifact-1",
  "contractName": "BullaClaim",
  "sourceName": "contracts/BullaClaim.sol",
  "abi": [
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_bullaId",
          "type": "uint256"
        },
        {
          "internalType": "address payable",
          "name": "_owner",
          "type": "address"
        },
        {
          "internalType": "address payable",
          "name": "_creditor",
          "type": "address"
        },
        {
          "internalType": "address payable",
          "name": "_debtor",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_claimAmount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_dueBy",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "bullaManager",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "bullaGroup",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "bullaId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "bullaClaim",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "enum BullaClaim.ActionType",
          "name": "actionType",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "paymentAmount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "enum BullaClaim.RejectReason",
          "name": "rejectReason",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "blocktime",
          "type": "uint256"
        }
      ],
      "name": "ClaimAction",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "bullaClaim",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "oldOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "trasferPrice",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "blocktime",
          "type": "uint256"
        }
      ],
      "name": "ClaimTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "bullaManager",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "bullaClaim",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "collectionAddress",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "transactionFee",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "blocktime",
          "type": "uint256"
        }
      ],
      "name": "FeePaid",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "bullaManager",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "bullaClaim",
          "type": "address"
        },
        {
          "components": [
            {
              "internalType": "bytes32",
              "name": "hash",
              "type": "bytes32"
            },
            {
              "internalType": "uint8",
              "name": "hashFunction",
              "type": "uint8"
            },
            {
              "internalType": "uint8",
              "name": "size",
              "type": "uint8"
            }
          ],
          "indexed": false,
          "internalType": "struct BullaClaim.Multihash",
          "name": "ipfsHash",
          "type": "tuple"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "blocktime",
          "type": "uint256"
        }
      ],
      "name": "MultihashAdded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "bullaClaim",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "oldPrice",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "newPrice",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "blocktime",
          "type": "uint256"
        }
      ],
      "name": "TransferPriceUpdated",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "hash",
          "type": "bytes32"
        },
        {
          "internalType": "uint8",
          "name": "hashFunction",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "size",
          "type": "uint8"
        }
      ],
      "name": "addMultihash",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "bullaGroup",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "bullaId",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "claimAmount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "creditor",
      "outputs": [
        {
          "internalType": "address payable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "debtor",
      "outputs": [
        {
          "internalType": "address payable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "dueBy",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getFeeInfo",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "address payable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "multihash",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "hash",
          "type": "bytes32"
        },
        {
          "internalType": "uint8",
          "name": "hashFunction",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "size",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address payable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paidAmount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "payClaim",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "enum BullaClaim.RejectReason",
          "name": "reason",
          "type": "uint8"
        }
      ],
      "name": "rejectClaim",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rescindClaim",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "newPrice",
          "type": "uint256"
        }
      ],
      "name": "setTransferPrice",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "status",
      "outputs": [
        {
          "internalType": "enum BullaClaim.Status",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address payable",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "transferPrice",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
